var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-topic-panel",
    {
      attrs: {
        title: "本日のおすすめ",
        name: "pickup",
        tooltip: "アクティブで応募につながり易い会員を自動抽出します。",
      },
    },
    [
      _vm.isPublished
        ? _c(
            "router-link",
            {
              staticClass: "boss-button boss-button-fill boss-button-pickup ",
              attrs: {
                to: {
                  name: "scoutRecommended",
                  params: { contractId: _vm.contractId, jobId: _vm.jobId },
                },
                "data-test": "recommendation-link",
              },
            },
            [
              _c("span", {
                staticClass: "boss-button-before boss-icon-triangle",
              }),
              _vm._v(" "),
              _c("span", [_vm._v("見る")]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }